Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
const textEdit_1 = require("./textEdit");
const shared = require("@volar/shared");
function transform(item, getOtherRange, document) {
    var _a;
    return Object.assign(Object.assign({}, item), { additionalTextEdits: (_a = item.additionalTextEdits) === null || _a === void 0 ? void 0 : _a.map(edit => (0, textEdit_1.transform)(edit, getOtherRange, document)).filter(shared.notEmpty), textEdit: item.textEdit
            ? (0, textEdit_1.transform)(item.textEdit, getOtherRange, document)
            : undefined });
}
exports.transform = transform;
//# sourceMappingURL=completionItem.js.map